// extracted by mini-css-extract-plugin
export var wrapper = "Steps-module--wrapper--3lmhL";
export var header = "Steps-module--header--1gvvQ";
export var logo = "Steps-module--logo--3Ct3m";
export var nav = "Steps-module--nav--2pPql";
export var link = "Steps-module--link--3uY3V";
export var navWrapper = "Steps-module--nav-wrapper--1H4c7";
export var steps = "Steps-module--steps--c_K2S";
export var step = "Steps-module--step--3N93P";
export var active = "Steps-module--active--3XRrq";
export var mobile = "Steps-module--mobile--1Umqy";
export var btnMenu = "Steps-module--btn-menu--3jPGv";
export var bar = "Steps-module--bar--3m61a";
export var close = "Steps-module--close--18TBh";
export var btnBackToTop = "Steps-module--btn-back-to-top--BZYv6";
export var globalNotification = "Steps-module--global-notification--3oufy";